import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { omit } from "radash"
import { z } from "zod"

import { devicesQueryOptions } from "../../../../features/devices/queries"

const devicesSearchSchema = z.object({
  search: z.coerce.string().optional().catch(""),
  deviceType: z.coerce.number().optional().catch(undefined),
  deviceModel: z.coerce.number().optional().catch(undefined),
  page: z.coerce.number().catch(1),
  pageSize: z.coerce.number().catch(10),
})

export const Route = createFileRoute("/_app/manage/devices/")({
  validateSearch: (search: SearchSchemaInput) =>
    devicesSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,

  loader: ({ context, deps }) => {
    return context.queryClient.ensureQueryData(
      devicesQueryOptions({
        params: {
          query: {
            ...omit(deps, ["deviceType"]),
            deviceType: deps.deviceType,
          },
        },
      })
    )
  },
})
